/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from "react"
import browserLang from "browser-lang"
import { withPrefix, GatsbyBrowser } from "gatsby"

// FormatJS Polyfill imports - Used for intl number formatting
import "@formatjs/intl-locale/polyfill"
import "@formatjs/intl-numberformat/polyfill"
import "@formatjs/intl-numberformat/locale-data/en"

import Layout from "./src/components/Layout"
import {
  supportedLanguages,
  defaultLanguage,
  isLang,
} from "./src/utils/languages"
import { IS_DEV } from "./src/utils/env"
import { Context } from "./src/types"

// Prevents <Layout/> from unmounting on page transitions
// https://www.gatsbyjs.com/docs/layout-components/#how-to-prevent-layout-components-from-unmounting
// @ts-ignore: returning `null` is not accepted by the `GatsbyBrowser` type def.
export const wrapPageElement: GatsbyBrowser<
  any,
  Context
>["wrapPageElement"] = ({ element, props }) => {
  const { location, pageContext } = props
  const { pathname, search } = location
  const { originalPath } = pageContext

  const [, pathLocale] = pathname.split("/")

  // client side redirect on paths that don't have a locale in them. Most useful
  // on dev env where we don't have server redirects
  if (IS_DEV && !isLang(pathLocale)) {
    let detected =
      window.localStorage.getItem("nutcoin-org-language") ||
      browserLang({
        languages: supportedLanguages,
        fallback: defaultLanguage,
      })

    if (!isLang(detected)) {
      detected = defaultLanguage
    }

    const queryParams = search || ""
    const newUrl = withPrefix(`/${detected}${originalPath}${queryParams}`)
    window.localStorage.setItem("nutcoin-org-language", detected)
    window.location.replace(newUrl)

    // override color mode by dark in local storage
    window.localStorage.setItem('chakra-ui-color-mode', "dark")

    return null
  }

  return <Layout {...props}>{element}</Layout>
}
